import React, { useContext } from 'react';
import { Row, Col, Form, Radio, Space, Checkbox } from 'antd';
import './styles.less';
import { PropTypes } from 'prop-types';
import DecretoModalLey from './DecretoModalLey';
import ModalRiskInvesrments from './ModalRiskInvesrments';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';

const FormInvestorProfile = ({ validateProfile, productos }) => {
  const { enrollment } = useContext(EnrollmentContext);
  const grupos = {};
  productos.forEach((product) => {
    const veId = product.vehicleId;
    if (!grupos[veId]) grupos[veId] = [];
    grupos[veId].push(product);
  });
  return (
    <Row className="formInvestorProfile">
      <Col className="formInvestorProfile__title">
        De acuerdo a su perfil de riesgo, puede operar los siguientes productos con Vantrust.
      </Col>
      <Col>
        <Form.Item name="products" rules={[{ required: true }]}>
          <Checkbox.Group>
            {productos.map((item) => (
              <>
                <Row>
                  <Col span={24} direction="vertical" className="formInvestorProfile__title">
                    {item.name}
                  </Col>
                </Row>
                {item.products.map((product) => (
                  <Col span={24} direction="vertical">
                    <Checkbox
                      onClick={() => validateProfile(product.id)}
                      value={product.id}
                      className={validateProfile(product.id, false) ? '' : 'resumen'}
                    >
                      <tituloVe className={validateProfile(product.id, false) ? '' : 'resumen2'}>
                        {product.description}
                      </tituloVe>

                      {product.type === 'RENTA_FIJA_INTERMEDIACION_FINANCIERA' ? (
                        <ul className={validateProfile(product.id, false) ? '' : 'resumen2'}>
                          <li>Intermediación en Renta Fija Local</li>
                          <li>Bonos</li>
                          <li>Depósitos a plazo</li>
                        </ul>
                      ) : (
                        ''
                      )}
                      {product.type === 'ADMINISTRACION_CARTERA' ? (
                        <ul className={validateProfile(product.id, false) ? '' : 'resumen2'}>
                          <li>Renta Fija Internacional en DCV</li>
                          <li>Bonos</li>
                          <li>Renta Variable Internacional en DCV</li>
                        </ul>
                      ) : (
                        ''
                      )}
                    </Checkbox>
                  </Col>
                ))}
                <Col span={24} direction="vertical">
                  {' '}
                  <hr />
                </Col>
              </>
            ))}
          </Checkbox.Group>
        </Form.Item>
      </Col>
      {enrollment.type === 'LEGAL' && (
        <>
          <Row>
            <Col lg={18} xs={23}>
              <Form.Item
                label="¿Es usted importador afecto al art. 3 del Decreto Ley Nº 3475 del año 1980??"
                name={['legalPerson', 'isSubjectToLaw3475']}
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Radio value>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Col span={24} className="formInvestorProfile__info">
            <DecretoModalLey />
          </Col>
        </>
      )}

      <br />

      <Col span={24} className="formInvestorProfile__info">
        <ModalRiskInvesrments />
      </Col>

      <Space direction="vertical">
        <Form.Item name="acceptsTerms" rules={[{ required: true }]}>
          <Checkbox>
            He leído y acepto la Contratación de productos no acorde con perfil de riesgo
          </Checkbox>
        </Form.Item>
      </Space>
    </Row>
  );
};

FormInvestorProfile.propTypes = {
  validateProfile: PropTypes.func.isRequired,
  productos: PropTypes.shape().isRequired,
};

export default FormInvestorProfile;
